<template>
  <div class="select" :class="[{ error: formField.hasError.value }, $attrs.class]">
    <select :id="formField.id" v-model="model" v-bind="$attrs">
      <slot />
    </select>
    <Icon class="icon" name="chevron-down" />
  </div>
</template>

<script setup lang="ts">
import { inject, ref, useAttrs } from 'vue';

import { FORM_FIELD_TOKEN } from './form-field/form-field.token';
import Icon from './icon.vue';

defineOptions({ inheritAttrs: false });

const model = defineModel();
const attrs = useAttrs();
const formField = inject(FORM_FIELD_TOKEN, {
  id: attrs.id as string,
  hasError: ref(false),
});
</script>

<style scoped lang="scss">
.select {
  --icon-size: var(--t-spacing-lg);
  --icon-margin-start: var(--t-spacing-sm);
  --select-padding-inline: var(--t-spacing-md);
  --select-height: var(--t-spacing-xxl);

  position: relative;
  display: inline-block;
  height: var(--select-height);

  background-color: var(--t-color-neutral-white);
  border: 1px solid var(--t-color-border-primary);
  border-radius: var(--t-border-radius-sm);

  select {
    appearance: none;
    width: 100%;
    height: 100%;
    padding-inline-start: var(--select-padding-inline);
    padding-inline-end: calc(var(--icon-margin-start) + var(--icon-size) + var(--select-padding-inline));

    position: relative;
    z-index: 1;

    border: none;
    background-color: transparent;

    color: var(--t-color-neutral-700);
    font: var(--t-typography-body-md-font);

    &:focus {
      color: var(--t-color-neutral-950);
      outline: none;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      border: none;
      -webkit-text-fill-color: inherit;
      -webkit-box-shadow: 0 0 0px 1000px var(--t-color-neutral-white) inset;
    }
  }

  &:has(select:focus) {
    border-color: var(--t-color-neutral-950);
    box-shadow: var(--t-form-field-focus-shadow);
  }

  &.error:has(:not(select:focus)) {
    border-color: var(--t-color-border-danger);
  }

  .icon {
    position: absolute;
    top: calc((var(--select-height) - var(--icon-size)) / 2);
    right: var(--select-padding-inline);
    color: var(--t-color-neutral-600);
  }
}
</style>
